import * as prismic from '@prismicio/client'
import * as prismicNext from '@prismicio/next'
import type { AllDocumentTypes } from '@root/prismicio-types'

/**
 * The project's Prismic repository name.
 */
export const repositoryName = `luneco`

export type ClientType = ReturnType<typeof prismic.createClient>

/**
 * A list of Route Resolver objects that define how a document's `url` field is resolved.
 *
 * {@link https://prismic.io/docs/route-resolver#route-resolver}
 */
const routes = [
    {
        type: 'blogpost_sliced',
        path: '/blog/:uid',
    },
]

/**
 * Creates a Prismic client for the project's repository. The client is used to
 * query content from the Prismic API.
 *
 * @param config - Configuration for the Prismic client.
 */
export const createClient = (config: prismicNext.CreateClientConfig = {}): ClientType => {
    console.log(`creating prismic client`)
    const client = prismic.createClient(repositoryName, {
        accessToken: process.env.PRISMIC_ACCESS_TOKEN,
        routes,
        fetchOptions:
            process.env.NODE_ENV === 'production'
                ? { next: { tags: ['prismic'] }, cache: 'force-cache' }
                : { next: { revalidate: 5 } },
        ...config,
    })
    console.log(`prismic client created`)

    prismicNext.enableAutoPreviews({
        client,
        previewData: config.previewData,
        req: config.req,
    })
    console.log(`prismic client auto previews enabled`)

    return client
}

/**
 * Fetches any Prismic by id. The caller needs to make sure the id exists
 *
 * @param id - Prismic id
 */
export async function get<T extends AllDocumentTypes>(
    client: ClientType,
    id: string,
): Promise<T['data'] & { uid: string }> {
    const doc = await client.getByID<T>(id)
    return {
        ...doc.data,
        uid: doc.uid!,
    }
}
